import * as React from 'react';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import styled from 'styled-components';
import { Global } from '@emotion/react';

const drawerBleeding = 56;

const HeaderStyledBox = styled.div`
  font-size: 18px;
  color: ${({ theme }) => theme.text1};
`;

const StyledBox = styled.div.attrs(() => ({
  className: 'drawer-scroll-container',
}))`
  color: ${({ theme }) => theme.text1};
  background-color: ${({ theme }) => theme.modalBg1};
  overflow-y: auto;
  padding: 8px;
  transition: padding-bottom 0.3s ease;
  height: calc(100%);
`;

const Puller = styled.div`
  width: 30px;
  height: 6px;
  background-color: ${({ theme }) => theme.lightGray};
  border-radius: 3px;
  position: absolute;
  top: 8px;
  left: calc(50% - 15px);
  z-index: 999;
`;

function SwipeableEdgeDrawer({
  children,
  openDrawer,
  handleCloseDrawer,
  title,
  drawerHeight = 0,
}) {
  const scrollRef = React.useRef(null);
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    setOpen(openDrawer);
  }, [openDrawer]);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
    if (!newOpen) {
      handleCloseDrawer();
    }
  };

  return (
    <>
      {/* {drawerHeight ? (
        <Global
          styles={{
            '.MuiDrawer-root > .MuiPaper-root': {
              height: drawerHeight,
              overflow: 'visible',
            },
          }}
        />
      ) : ( */}
      <Global
        styles={{
          '.MuiDrawer-root > .MuiPaper-root': {
            height: 'calc(95% - env(safe-area-inset-top) - env(safe-area-inset-bottom))',
            overflow: 'visible',
            paddingBottom: 'env(safe-area-inset-bottom)',
          },
        }}
      />
      {/* )} */}
      <SwipeableDrawer
        anchor="bottom"
        open={open}
        onClose={toggleDrawer(false)}
        disableSwipeToOpen={true}
        swipeAreaWidth={0}
        keepMounted
        disableDiscovery={true}
      >
        <HeaderStyledBox
          sx={{
            position: 'absolute',
            top: -drawerBleeding,
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
            visibility: 'visible',
            right: 0,
            left: 0,
          }}
        >
          <Puller />
          {title && (
            <div
              style={{ marginTop: 16, textAlign: 'center', fontWeight: 600 }}
            >
              {title}
            </div>
          )}
        </HeaderStyledBox>
        {open && <StyledBox ref={scrollRef}>{children}</StyledBox>}
      </SwipeableDrawer>
    </>
  );
}

export default SwipeableEdgeDrawer;
